import ChangeHighglightedImmutableUnderReviewDropdown from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighglightedImmutableUnderReviewDropdown';
import React from 'react';
export default function BusinessUnitDropdown(_ref) {
  let {
    claim,
    costFragment,
    userUnauthorizedToEdit,
    onChange,
    onBlur,
    refreshClaim
  } = _ref;
  return /*#__PURE__*/React.createElement(ChangeHighglightedImmutableUnderReviewDropdown, {
    claim: claim,
    valuesArray: claim.company.business_units,
    valueInstanceTextFieldName: 'name',
    edittedObject: costFragment,
    edittedObjectFieldName: 'business_unit_id',
    userUnauthorizedToEdit: userUnauthorizedToEdit,
    onChange: onChange,
    onBlur: onBlur,
    refreshClaim: refreshClaim,
    onCreate: false
  });
}